import {Ten99Filters} from 'Agent/1099s/ducks/1099';
import {TaxStatementsApi} from 'Agent/Commissions/api';
import {getAxiosConfig, handleResponse, withCancellation} from 'Shared/utilities/fetchHelpers';
import axiosInstance from 'Shared/utilities/axiosInstance';

export const ten99RootUri = '/commissions/taxStatements';

const ten99Api = new TaxStatementsApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

const getTen99s = (encryptedIdentifier: string, isNewYork: boolean, filter?: Ten99Filters) =>
  withCancellation(cancelToken =>
    ten99Api.searchTaxStatements('1', {
      ...getAxiosConfig(cancelToken),
      params: {encryptedIdentifier, isNewYork, ...filter},
    })
  ).then(handleResponse);

export default {
  getTen99s,
};
